import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Database, Shield, Code, Terminal, Server } from 'lucide-react';

const experience = [
  {
    title: 'Network Systems',
    description: 'Network infrastructure and systems management',
    icon: Globe,
    tech: 'CISCO (Switch, Packet Tracer)'
  },
  {
    title: 'Database Management',
    description: 'Database design and administration',
    icon: Database,
    tech: 'SQL, MariaDB'
  },
  {
    title: 'Cybersecurity',
    description: 'PFSense (HA, PROXY, FIREWALL), Nessus, Nmap, Security protocols',
    icon: Shield,
    tech: 'Security'
  },
  {
    title: 'Web Development',
    description: 'Frontend & Backend development with PHP',
    icon: Code,
    tech: 'HTML/CSS/PHP'
  },
  {
    title: 'Advanced OS Management and Virtualization',
    description: 'Ubuntu, Kali Linux, Windows Server (Virtual Box, Hyper-V)',
    icon: Terminal,
    tech: 'AD, LDAP, SAMBA, NFS, RDP, XRDP, VM, etc...'
  },
  {
    title: 'Network Services',
    description: 'HTTP/S, MAIL, DNS, DHCP, etc...',
    icon: Server,
    tech: 'Services'
  }
];

const projects = [
  {
    title: 'Online Shop',
    description: 'E-commerce platform with admin dashboard',
    link: '/projects/shop/index.php',
    tech: 'Full Stack'
  },
  {
    title: 'WordPress',
    description: 'Custom WordPress development',
    link: '/projects/wp/',
    tech: 'WordPress/PHP'
  },
  {
    title: 'YouTube Playlist Randomizer',
    description: 'AI-powered',
    link: 'https://robinexus.com/projects/randomizer/index.html',
    tech: 'Full Stack'
  },
  {
    title: 'EMR Project',
    description: 'JRA ACADEMY',
    link: '/projects/emr/index.html',
    tech: 'HTML'
  },
  {
    title: 'SGY LOPDGDD/RGPD',
    description: 'Presentation on data protection laws.',
    link: 'https://robinexus.com/projects/sgy/index.html',
    tech: 'HTML'
  },
  {
    title: 'Online shop 2.0 (Apartments)',
    description: 'AI-powered Online Shop',
    link: 'https://robinexus.com/',
    tech: 'Full Stack'
  }
];

const ExperienceCard = ({ item, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group p-6 bg-white/5 backdrop-blur-sm rounded-lg hover:bg-white/10 transition-all duration-300"
    >
      <item.icon className="w-8 h-8 mb-4 text-gray-400 group-hover:text-white transition-colors" />
      <h3 className="text-lg font-semibold mb-2 text-gray-200 group-hover:text-white">
        {item.title}
      </h3>
      <p className="text-gray-400 text-sm mb-4 group-hover:text-gray-300">
        {item.description}
      </p>
      <span className="inline-block text-xs px-2 py-1 rounded bg-white/10 text-gray-300">
        {item.tech}
      </span>
    </motion.div>
  );
};

const ProjectCard = ({ project, index }) => {
  return (
    <motion.a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group p-6 bg-white/5 backdrop-blur-sm rounded-lg hover:bg-white/10 transition-all duration-300"
    >
      <h3 className="text-lg font-semibold mb-2 text-gray-200 group-hover:text-white flex items-center">
        {project.title}
        <Code className="w-4 h-4 ml-2 inline-block opacity-0 group-hover:opacity-100 transition-opacity" />
      </h3>
      <p className="text-gray-400 text-sm mb-4 group-hover:text-gray-300">
        {project.description}
      </p>
      <span className="inline-block text-xs px-2 py-1 rounded bg-white/10 text-gray-300">
        {project.tech}
      </span>
    </motion.a>
  );
};

const Projects = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        {/* Experience Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="mb-20"
        >
          <h2 className="text-2xl font-light text-center mb-16 text-gray-200">
            Experience
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {experience.map((item, index) => (
              <ExperienceCard key={index} item={item} index={index} />
            ))}
          </div>
        </motion.div>

        {/* Projects Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          <h2 className="text-2xl font-light text-center mb-16 text-gray-200">
            Projects
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {projects.map((project, index) => (
              <ProjectCard key={index} project={project} index={index} />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;